import { useEffect } from "react";

import { TOUR_LOCK_SCROLL_ATTR } from "@/components/Playground/tour/constants";

const isInsideLockedContainer = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) {
    return false;
  }
  return target.closest(`[${TOUR_LOCK_SCROLL_ATTR}]`) !== null;
};

/**
 * Blocks user wheel/touch on any `[data-tour-lock-scroll]` container so the
 * highlighted widget can't be dragged out from under the tour spotlight.
 * Programmatic `scrollIntoView` still works — only user gestures are
 * intercepted. Document-level so it works with the chat-mode messages
 * container's shared @hello-pangea/dnd ref.
 */
export const useTourScrollLock = (active: boolean): void => {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const handleWheel = (event: WheelEvent) => {
      if (isInsideLockedContainer(event.target)) {
        event.preventDefault();
      }
    };

    const handleTouchMove = (event: TouchEvent) => {
      if (isInsideLockedContainer(event.target)) {
        event.preventDefault();
      }
    };

    document.addEventListener("wheel", handleWheel, { passive: false });
    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener("wheel", handleWheel);
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, [active]);
};
